import signup from './signup'
import confirmEmail from './confirm-email'
import updateCurrentUserByToken from './update-current-user-by-token'
import changePassword from './change-password'
import restorePasswordByEmail from './restore-password-by-email'
import signinLegacy from './signin-legacy'

const services = {
  signup,
  confirmEmail,
  updateCurrentUserByToken,
  changePassword,
  restorePasswordByEmail,
  signinLegacy,
}

export default services
